<template>
  <div class="list">
    <template v-for="(value, key) in list">
      <div
          class="list-row"
      >
        <span class="key">
            {{ key }}
        </span>
        <span class="value">
            {{ value }}
        </span>

      </div>
      <hr class="divider">
    </template>

  </div>
</template>

<script>
export default {
  name: "CardList.vue",
  props: {
    list: Object,
  },
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";

.list {
  width: 100%;
  display: flex;
  flex-direction: column;

  .list-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: $spacing-sm 0;

    .key {
      font-weight: 400;
      color: $text-color;
    }

    .value {
      font-weight: 400;
      color: $brand-primary;
    }
  }

  .divider {
    margin: 0;
    border: 1px solid #EEF2F6;
  }

  .divider:last-of-type {
    display: none;
  }
}

</style>